// src/pages/index.tsx
import Landing from "components/organisms/Landing";
const Home = () => {
  return <>
            <Landing data-sentry-element="Landing" data-sentry-source-file="index.tsx" />
        </>;
};
export default Home;